import type {
	IAddonProductConstructorParams,
	IBoosterProductConstructorParams,
	IDeliveryProductConstructorParams,
	IPlanProductConstructorParams,
} from "@services/sdk";
import AddonProduct from "@services/sdk/models/addon-product";
import BoosterProduct from "@services/sdk/models/booster-product";
import DeliveryProduct from "@services/sdk/models/delivery-product";
import PlanProduct from "@services/sdk/models/plan-product";
import type Product from "@services/sdk/models/product";
import { ProductTypeEnum } from "@services/sdk/models/product-type";

class ProductGrouper {
	public static GroupByType(products: Array<Product>): {
		planProducts: Array<PlanProduct>;
		addonProducts: Array<AddonProduct>;
		boosterProducts: Array<BoosterProduct>;
		deliveryProducts: Array<DeliveryProduct>;
	} {
		let planProducts: Array<PlanProduct> = [];
		let addonProducts: Array<AddonProduct> = [];
		let boosterProducts: Array<BoosterProduct> = [];
		let deliveryProducts: Array<DeliveryProduct> = [];

		products.forEach((product) => {
			switch (product.type) {
				case ProductTypeEnum.PLAN:
					planProducts = [
						...planProducts,
						PlanProduct.Construct(
							<IPlanProductConstructorParams>product.responseData,
						),
					];
					break;
				case ProductTypeEnum.ADDON:
					addonProducts = [
						...addonProducts,
						AddonProduct.Construct(
							<IAddonProductConstructorParams>product.responseData,
						),
					];
					break;
				case ProductTypeEnum.BOOSTER:
					boosterProducts = [
						...boosterProducts,
						BoosterProduct.Construct(
							<IBoosterProductConstructorParams>product.responseData,
						),
					];
					break;
				case ProductTypeEnum.DELIVERY:
					deliveryProducts = [
						...deliveryProducts,
						DeliveryProduct.Construct(
							<IDeliveryProductConstructorParams>product.responseData,
						),
					];
					break;
				default:
				// do nothing
			}
		});

		return {
			planProducts,
			addonProducts,
			boosterProducts,
			deliveryProducts,
		};
	}
}

export default ProductGrouper;
